import { trackWidgetImpression } from 'modules/impressions/utils'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { WidgetImpressionSource } from 'types/targeting'

const useTrackImpressionOnce = (source: WidgetImpressionSource = WidgetImpressionSource.LIVE_CHAT) => {
  const [tracked, setTracked] = useState(false)
  const { chatOpen } = useSelector(state => (
    state.view
  ))


  useEffect(() => {
    const trackImpression = async () => {
      if (chatOpen && !tracked) {
        const didSend = await trackWidgetImpression(source)
        setTracked(didSend)
      }
    }

    trackImpression()
  }, [tracked, chatOpen, source])
}

export default useTrackImpressionOnce
